"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RENTAL_AGREEMENT_HISTORY_TYPES = void 0;
exports.RENTAL_AGREEMENT_HISTORY_TYPES = Object.freeze({
    INITIAL: 'initial',
    STEP_UP: 'step_up',
    RENEWAL: 'renewal',
    HOLDOVER: 'holdover'
});
